export default __webpack_public_path__ + "assets/images/9af4867aa087d0dbd9b0b2ee5d80b461.jpg";